import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../../_app/types";

const ChevronLeft = ({ size }: PropsAdronIcon) => {
  const theme: Theme = useTheme();
  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : "0 0 24 24"}
      style={size ? { width: size, height: size } : { width: 24, height: 24 }}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.1269 4.13145L10.1269 4.13146L5.6269 8.93146L5.26213 8.58949L5.6269 8.93146C5.59084 8.96993 5.59084 9.02978 5.6269 9.06825L5.2629 9.4095L5.6269 9.06825L10.1269 13.8682C10.1269 13.8682 10.1269 13.8683 10.1269 13.8683C10.1646 13.9085 10.2279 13.9106 10.2682 13.8729C10.3085 13.8351 10.3106 13.7718 10.2728 13.7314C10.2728 13.7314 10.2728 13.7314 10.2728 13.7314L6.15752 9.34183L5.83692 8.99986L6.15752 8.65788L10.2728 4.26826C10.2728 4.26825 10.2728 4.26825 10.2728 4.26825C10.3106 4.22796 10.3085 4.16469 10.2683 4.12691L10.1269 4.13145ZM10.1269 4.13145C10.1647 4.09119 10.2279 4.08912 10.2682 4.12689L10.1269 4.13145Z"
          fill={theme.palette.text.primary}
          stroke={theme.palette.text.primary}
        />
      </svg>
    </SvgIcon>
  );
};

export default ChevronLeft;
